import React from "react";
import { UserState } from "redux-oidc";
import { ImageGallery } from "../Common/ImageGallery";
import { FeatureRequest } from "../..";
import { TextDisplay, DateDisplay } from "../../../Common";
import FeedbackFileDisplay from "../Common/FeedbackFileDisplay/FeedbackFileDisplay";
import { userService } from "../../../User";
import { commentLinkSplitService } from "../../Services/CommentLinkSplitService";

type Props = {
  feedback: FeatureRequest;
  user: UserState;
};

export const FeatureRequestDetails: React.FC<Props> = props => {
  const isCMUser = userService.isUserCadmakers(props.user);

  return (
    <div>
      {isCMUser && (
        <div>
          <div style={{ display: "inline-block", marginRight: "10%" }}>
            <h4>Start Date</h4>
            {props.feedback.startDate ? (
              <DateDisplay date={new Date(props.feedback.startDate)} />
            ) : (
              <TextDisplay>N/A</TextDisplay>
            )}
          </div>
          <div style={{ display: "inline-block" }}>
            <h4>Estimated Hours</h4>
            <TextDisplay>
              {props.feedback.estimatedHours ? props.feedback.estimatedHours : "N/A"}
            </TextDisplay>
          </div>
        </div>
      )}
      <div>
        <h4>Description</h4>
        <TextDisplay>
          {commentLinkSplitService.getLinkDisplay(props.feedback.description ?? "")}
        </TextDisplay>
      </div>
      <div>
        <h4>Feature Requirements</h4>
        <TextDisplay>{props.feedback.featureRequirements}</TextDisplay>
      </div>
      {props.feedback.files.length > 0 && (
        <div>
          <h4>Files</h4>
          <FeedbackFileDisplay
            files={props.feedback.files.filter(f => isCMUser || !f.isCadmakersOnly)}
          />
          <br />
        </div>
      )}
      <ImageGallery images={props.feedback.images} />
    </div>
  );
};
